<template>
<span v-if="isArchivePpaClosed">
    <span v-if="!isApprovedPpaConfirmationActive">
      <span :id="instanceId" :name="instanceId">
        <div class="quick-action" v-if="!isApprovedPpaConfirmationActive && !showStatusIcon">
          <button class="button" @click="onViewApprovedPpaValue()" :title="applicableIconTitle" v-if="!showStatusIcon">
            <b-icon pack="fal" icon="check-circle" custom-size="fa-lg" :class="formatIconByStatus"></b-icon>
          </button>
        </div>
        <span v-if="showStatusIcon" @click.stop.prevent="onViewApprovedPpaValue()">
          <i class="grid-icon fa-fw fal fa-check-circle fa-lg clickable" :class="formatIconByStatus" :title="applicableIconTitle"/>
        </span>
      </span>
    </span>
    <portal to="global-modal-portal" v-else :disabled="!usePortal">
      <b-modal :active.sync="isApprovedPpaConfirmationActive" :full-screen="true" scroll="keep" :has-modal-card="true" :canCancel="false" class="modal-fullscreen">
        <div class="modal-card">
          <header class="modal-card-head">
            <div class="columns" style="width: 100%">
              <div class="column is-4 is-pulled-left">
                <span class="modal-card-title">{{modalTitle}}</span>
              </div>
              <div class="column is-8">
                <div class="tags are-medium is-pulled-right">
                  <a class="tag is-primary" @click.stop.prevent="onStockNoClick(inventoryItem)">
                    {{ stockNo }}
                  </a>
                  <span class="tag is-primary">{{ inventoryDetails }}</span>
                  <span class="tag is-primary">{{ inventoryItem.vinNo }}</span>
                </div>
              </div>
            </div>
          </header>
          <section class="modal-card-body" v-if="isLoading">
            <b-loading :is-full-page="false" :active.sync="isLoading" :canCancel="false"></b-loading>
          </section>
          <section class="modal-card-body" v-else>
            <error-display-component :serverErrors="serverErrors" :serverErrorMessage="serverErrorMessage"></error-display-component>
            <form @submit.prevent="validateBeforeSubmit">
              <div class="columns">
                <div class="column is-6">
                  <div class="columns is-multiline">
                    <div class="column is-3 is-narrow">
                      <div class="field">
                        <label class="label">PPA Intention<b-icon pack="fas" icon="star" class="fa-ss"></b-icon></label>
                        <div class="field">
                          <span>{{ ppaIntentionValue }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="column  is-narrow is-4" v-if="showCpoStatus">
                      <div class="field">
                        <label class="label">CPO Intention</label>
                        <div class="field">
                          <span>{{ cpoStatusValue }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="column  is-narrow is-5">
                      <div class="field">
                        <label class="label">Condition</label>
                        <div class="field">
                          <span>{{ conditionTypeValue }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="column  is-narrow is-6">
                      <div class="field">
                        <label class="label">Disposition Intention<b-icon pack="fas" icon="star" class="fa-ss"></b-icon></label>
                        <div class="field">
                          <span>{{ dispositionIntentionStatusValue }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="column  is-narrow is-6" v-if="selectedDispositionIntentionStatus && selectedDispositionIntentionStatus.id === 3">
                      <div class="field">
                        <label class="label">Retail Day Limit<b-icon pack="fas" icon="star" class="fa-ss"></b-icon></label>
                        <div class="field">
                          <span>{{ selectedDispositionDay }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="column is-3 is-narrow">
                      <div class="field">
                        <label class="label">Mileage<b-icon pack="fas" icon="star" class="fa-ss"></b-icon></label>
                        <div class="field">
                          {{ currentInventory.usage }}
                        </div>
                      </div>
                    </div>
                    <div class="column is-3 is-narrow">
                      <div class="field">
                        <label class="label">Mileage Estimated<b-icon pack="fas" icon="star" class="fa-ss"></b-icon></label>
                        <div class="field">
                          {{ currentInventory.mileageEstimate | yesno }}
                        </div>
                      </div>
                    </div>
                    <div class="column is-3 is-narrow">
                      <div class="field">
                        <label class="label">True Mileage Unknown<b-icon pack="fas" icon="star" class="fa-ss"></b-icon></label>
                        <div class="field">
                          {{ currentInventory.trueMileageUnknown | yesno }}
                        </div>
                      </div>
                    </div>
                    <div class="column is-3 is-narrow" v-if="currentInventory.mileageEstimate">
                      <div class="field">
                        <label class="label">Mileage Exempt</label>
                        <div class="field">
                          {{ currentInventory.mileageExempt | yesno }}
                        </div>
                      </div>
                    </div>
                    <div class="column is-6 is-narrow" v-if="selectedDispositionIntentionStatus && selectedDispositionIntentionStatus.id === 2">
                      <div class="field">
                        <label class="label">Has Commitment</label>
                        <div class="field">
                          {{ this.hasCommitment | yesno }}
                        </div>
                      </div>
                    </div>
                    <div class="column is-6 is-narrow" v-if="selectedDispositionIntentionStatus && selectedDispositionIntentionStatus.id === 2 && hasCommitment">
                      <div class="field">
                        <label class="label">Commitment from</label>
                        <div class="field">
                          {{ this.currentInventory.commitmentFromName || '-' }}
                        </div>
                      </div>
                    </div>
                    <div class="column is-6 is-narrow" v-if="selectedDispositionIntentionStatus && selectedDispositionIntentionStatus.id === 2 && hasCommitment">
                      <div class="field">
                        <label class="label">Firm Commitment</label>
                        <div class="field">
                          {{ this.currentInventory.firmCommitment | yesno }}
                        </div>
                      </div>
                    </div>
                    <div class="column is-6 is-narrow" v-if="selectedDispositionIntentionStatus && selectedDispositionIntentionStatus.id === 2 && hasCommitment">
                      <div class="field">
                        <label class="label">Commitment Value<b-icon pack="fas" icon="star" class="fa-ss"></b-icon></label>
                        <div class="field">
                          {{ this.currentInventory.commitmentValue | currency }}
                        </div>
                      </div>
                    </div>

                    <div class="column is-6 is-narrow">
                      <div class="field">
                        <label class="label">{{ proposedCostLabel }}<b-icon pack="fas" icon="star" class="fa-ss"></b-icon></label>
                        <div class="field">
                          {{ this.currentInventory.proposedCost | currency }}
                        </div>
                      </div>
                    </div>
                    <div class="column is-6 is-narrow">
                      <div class="field">
                        <label class="label">{{ proposedCostExpirationLabel }}</label>
                        <div class="field">
                          {{ this.currentInventory.proposedCostExpirationDate | formatDate }}
                        </div>
                      </div>
                    </div>
                    <div class="column is-6 is-narrow" v-if="isTradePpaIntention">
                      <div class="field">
                        <label class="label">Proposed Trade Allowance</label>
                        <div class="field">
                          {{ this.currentInventory.proposedTradeAllowance | currency }}
                        </div>
                      </div>
                    </div>
                    <div class="column is-6 is-narrow" v-if="isTradePpaIntention">
                      <div class="field">
                        <label class="label">Payoff Amount</label>
                        <div class="field">
                          {{ currentInventory.payoffAmount | currency }}
                        </div>
                      </div>
                    </div>

                    <div class="column is-4 is-narrow">
                      <div class="field">
                        <label class="label">Has vehicle been visually inspected?</label>
                        <div class="field">
                          <span>{{ this.currentInventory.ppaExamined | yesno }}</span>
                          <br/>
                          <label class="label-frontgp is-pulled-left" v-tooltip="'Examined By/Examined At'" v-if="currentInventory.ppaExamined && currentInventory.ppaExaminedBy !== ''">{{ppaInfo}}</label>
                        </div>
                      </div>
                    </div>
                    <div class="column is-4 is-narrow">
                      <div class="field">
                        <label class="label">Create service inspection?</label>
                        <div class="field">
                          {{ this.currentInventory.serviceInspectionRequest | yesno }}
                        </div>
                      </div>
                    </div>
                    <div class="column is-4 is-narrow">
                      <div class="field">
                        <label class="label">Value is dependent on vehicle inspection?</label>
                        <div class="field">
                          {{ this.currentInventory.inspectionDependent | yesno }}
                        </div>
                      </div>
                    </div>

                    <div class="column is-12">
                      <div class="box">
                        <h6 class="title is-size-6">Proposed Costs</h6>
                        <b-table
                          :sortable="false"
                          :mobile-cards="false"
                          :selecteable="false"
                          :data="currentInventory.proposedCosts">
                          <template slot-scope="props">
                            <b-table-column field="proposedCost" label="Proposed Cost">
                              {{ props.row.proposedCost | currency }}
                            </b-table-column>
                            <b-table-column field="proposedTradeAllowance" label="Proposed Trade Allowance">
                              {{ props.row.proposedTradeAllowance | currency }}
                            </b-table-column>
                            <b-table-column field="ppaIntention" label="PPA Intention">
                              {{ props.row.ppaIntention }}
                            </b-table-column>
                            <b-table-column field="createdAt" label="Created At">
                              {{ props.row.createdAt | formatDateOnly }}
                            </b-table-column>
                            <b-table-column field="createdByName" label="Created By">
                              {{ props.row.createdByName }}
                            </b-table-column>
                          </template>

                          <template slot="empty">
                            <section class="section">
                              <div class="has-text-centered">
                                <p><b-icon icon="emoticon-sad" size="is-large"></b-icon></p>
                                <p>No proposed costs.</p>
                              </div>
                            </section>
                          </template>
                        </b-table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column is-6">
                  <div class="columns is-multiline">
                    <div class="column is-12">
                      <car-fax-control
                        :inventory="currentInventory"
                        title="CarFax Vehicle Status"
                        :carFaxRating="currentInventory.carFaxRating"
                        :vinNo="currentInventory.vinNo"
                        :displayOnly="false"
                        v-on:on-new-carfax="onCarFaxForApprovePpa"
                        v-on:on-carfax-failed="onCarFaxForApprovePpa"
                        :runAutomatically="false"
                        :autoUpdateInventory="false"
                        :modalContainer="true"
                        v-on:on-show-carfax-report="onShowCarFaxReport"
                        :showRefresh="false"
                        :loginEnabled="false"
                        :usePdfModalPortal="false"
                        :resolveActionDisabled="true">
                      </car-fax-control>
                    </div>
                    <!-- <div class="column is-12">
                      <auto-check-control
                        v-if="autoCheckEnabled"
                        :inventory="currentInventory"
                        title="AutoCheck Vehicle Status"
                        :autoCheckRating="currentInventory.autoCheckRating"
                        :vinNo="currentInventory.vinNo"
                        :displayOnly="false"
                        v-on:on-new-autocheck="onAutoCheckForApprovePpa"
                        v-on:on-autocheck-failed="onAutoCheckForApprovePpa"
                        :runAutomatically="true"
                        :autoUpdateInventory="true"
                        :modalContainer="true"
                        v-on:on-show-autocheck-report="onShowAutoCheckReport"
                        :showRefresh="false"
                        :purchasedFromType="currentInventory.purchasedFromType"
                        :inventoryType="selectedInventoryStatusType"
                        v-on:autocheck-disabled="onAutoCheckDisabled">
                      </auto-check-control>
                    </div> -->
                    <div class="column is-12">
                      <div>
                        <div class="columns box is-multiline is-centered vauto-container" style="position: relative; z-index: 2000;">
                          <div class="vauto-container-display-only column is-12">
                            <div style="width:100%">
                              <h3 data-v-74fd810e="" class="title is-6 is-inline-block is-marginless">vAuto Vehicle Status</h3>
                            </div>
                          </div>
                          <div class="column is-12">
                            <a v-if="hasVautoAppraisal" :href="currentInventory.vAutoAppId" target="_vauto" title="Click to view the latest vAuto report for this vehicle."><img src="@/assets/static/vauto/vauto_logo_small.png" style="width:90px; height:auto;"></a>
                            <img v-else title="vAuto report is pending" src="@/assets/static/vauto/vauto_logo_small.png" style="width:90px; height:auto;" class="img-disabled">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="column is-12 mt-10">
                      <inventory-appraisal-control
                        :key="currentInventory.id"
                        v-if="hasFeatureAccess('inventory.appraisal.view')"
                        :appraisedValue="mostRecentAppraisal"
                        displayMode="Compact"
                        :inventory="inventoryAppraisalParams"
                        v-on:on-new-appraisal="onAppraised"
                        v-on:on-appraisal-failed="onAppraised"
                        :runAutomatically="false"
                        :autoUpdateInventory="false"
                        :inventoryType="currentInventory.type"
                        :allowSync="false">
                      </inventory-appraisal-control>
                    </div>
                    <div class="column is-12 mt-10" v-if="blackBookEnabled">
                      <inventory-black-book-control
                      :blackBookInformation="mostRecentBlackBookInformation"
                      :inventory="inventoryAppraisalParams"
                      v-on:on-new-blackbook-information="onBlackBookInformationRetrieved"
                      :runAutomatically="false"
                      :autoUpdateInventory="false"
                      :inventoryType="currentInventory.type"
                      v-on:on-blackbook-information-failed="onBlackBookInformationRetrieved"
                      v-on:black-book-disabled="onBlackBookDisabled"
                      :allowSync="false">
                      </inventory-black-book-control>
                    </div>
                    <div class="column is-12 mt-10">
                      <customer-info-control
                        :key="currentInventory.id"
                        :runAutomatically="false"
                        :customerNameLabel="'Purchased From'"
                        :customerId="currentInventory.purchasedFromId"
                        :customerMobile="currentInventory.purchasedFromContactMobile"
                        :customerEmail="currentInventory.purchasedFromContactEmail"
                        :allowSync="false"
                        :inventoryId="currentInventory.id">
                      </customer-info-control>
                    </div>
                    <div class="column is-12 mt-10">
                      <div class="box">
                        <section-header title="Attachments"></section-header>
                        <div class="columns">
                          <div class="column is-4 is-narrow">
                            <div class="field">
                              <label class="label">Window Sticker Status</label>
                              <div class="field">
                                {{ this.currentInventory.windowStickerStatus }}
                              </div>
                            </div>
                          </div>
                          <div class="column is-4">
                            <image-selector
                              v-model="windowStickerFiles"
                              label="Window Sticker Image"
                              :disabled="true"
                              :required="false"
                              :isBoxed="false"
                              v-if="selectedWindowStickerStatus && selectedWindowStickerStatus.id === 0"
                              @uploadStarted="uploadStarted"
                              @uploadComplete="uploadComplete">
                            </image-selector>
                          </div>
                          <div class="column is-4">
                            <pdf-selector
                            v-model="windowStickerPdfFiles"
                            label="Window Sticker Pdf"
                            :enabled="false"
                            :required="false"
                            :isBoxed="false"
                            v-if="selectedWindowStickerStatus && selectedWindowStickerStatus.id === 0"
                            @uploadStarted="uploadStarted"
                            @uploadComplete="uploadComplete"
                            :usePdfModalPortal="false"></pdf-selector>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </section>
          <footer class="modal-card-foot">
            <div class="columns" style="width: 100%">
              <div class="column is-8 is-pulled-left">
                <button class="button is-danger" @click="onCancel()">Close</button>
              </div>
            </div>
          </footer>
        </div>
      </b-modal>
    </portal>
    <auto-check-report-control
      :inventory="currentInventory"
      title="AutoCheck Vehicle Status"
      :vinNo="currentInventory.vinNo"
      v-on:on-hide-autocheck-report="onHideAutoCheckReport"
      :showAutoCheckReportModal="showReport"
      v-if="currentInventory && autoCheckEnabled">
    </auto-check-report-control>
    <car-fax-report-control
      title="CarFax Vehicle Status"
      v-on:on-hide-carfax-report="onHideCarFaxReport"
      :showCarFaxReportModal="showCarFaxReport"
      :carFaxReportUrl="carFaxReportUrl"
      v-if="currentInventory">
    </car-fax-report-control>
  </span>
</template>

<script>

import eventBus from '@/eventBus'
import moment from 'moment'
import inventoryService from '../../services/inventoryService'
import ErrorDisplayComponent from '@/components/generic/ErrorDisplayComponent'
import validateBeforeSubmitMixin from '@/mixins/generic/validateBeforeSubmit'
import formattingMixin from '@/mixins/inventory/formatting'
import AutoCheckControl from '@/components/generic/AutoCheckControl'
import AutoCheckReportControl from '@/components/generic/AutoCheckReportControl'
import CarFaxControl from '@/components/generic/CarFaxControl'
import CarFaxReportControl from '@/components/generic/CarFaxReportControl'
import CustomerInfoControl from '@/components/generic/CustomerInfoControl'
import InventoryAppraisalControl from '@/components/generic/InventoryAppraisalControl'
import utilitiesMixin from '@/mixins/generic/utilities'
import SectionHeader from '@/components/generic/SectionHeader'
import ImageSelector from '@/components/generic/ImageSelector'
import PdfSelector from '@/components/generic/PdfSelector'
import InventoryBlackBookControl from '@/components/generic/InventoryBlackBookControl'

import { createNamespacedHelpers } from 'vuex'
const mapDealerState = createNamespacedHelpers('dealer').mapState
const mapConfigGetters = createNamespacedHelpers('config').mapGetters
const mapUserGetters = createNamespacedHelpers('user').mapGetters

export default {
  name: 'ViewApprovedPpaValue',
  mixins: [validateBeforeSubmitMixin, formattingMixin, utilitiesMixin],
  props: {
    inventoryItem: {
      type: Object,
      default: null
    },
    showStatusIcon: {
      type: Boolean,
      default: false
    },
    usePortal: {
      type: Boolean,
      default: true
    },
    reloadList: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isApprovedPpaConfirmationActive: false,
      isSaving: false,
      serverErrors: [],
      serverErrorMessage: '',
      instanceId: this.$uuid.v4(),
      currentInventory: null,
      isLoading: false,
      showReport: false,
      modalWidth: (window.innerWidth * 70 / 100),
      showCarFaxReport: false,
      selectedPpaIntention: null,
      selectedDispositionIntentionStatus: null,
      hasCommitment: false,
      selectedCommitmentFrom: null,
      selectedCpoStatus: null,
      selectedConditionType: null,
      windowStickerPdfFiles: [],
      windowStickerFiles: [],
      selectedWindowStickerStatus: null,
      isUploadingFile: false,
      fileUploadCount: 0,
      blackBookInformation: null,
      blackBookCheckComplete: false,
      blackBookCheckIsGood: false,
      blackBookCheckFailed: false
    }
  },
  components: {
    'error-display-component': ErrorDisplayComponent,
    'auto-check-control': AutoCheckControl,
    'auto-check-report-control': AutoCheckReportControl,
    'car-fax-control': CarFaxControl,
    'car-fax-report-control': CarFaxReportControl,
    'customer-info-control': CustomerInfoControl,
    'inventory-appraisal-control': InventoryAppraisalControl,
    'section-header': SectionHeader,
    'image-selector': ImageSelector,
    'pdf-selector': PdfSelector,
    'inventory-black-book-control': InventoryBlackBookControl
  },
  computed: {
    ...mapDealerState(['currentDealer']),
    ...mapConfigGetters(['definedTypes']),
    ...mapUserGetters(['hasFeatureAccess', 'currentUser', 'lastActiveListPage']),
    isMakeSoldByDealer: function () {
      if (!this.currentInventory) return false

      if (!this.currentInventory.vehicleMakeId) return false

      if (!this.currentDealer.sellsVehicleMakes.find((x) => x.vehicleMakeId === this.currentInventory.vehicleMakeId)) return false

      return true
    },
    showCpoStatus: function () {
      if (!this.inventoryItem) return false

      if (!this.isMakeSoldByDealer) return false

      if (this.currentDealer.isWholesaleDealer) return false

      if (!this.currentInventory.typeId) {
        return false
      } else {
        return [1, 3, 4, 5].indexOf(this.currentInventory.typeId) >= 0
      }
    },
    isTradePpaIntention: function () {
      return this.selectedPpaIntention && this.selectedPpaIntention.name === 'Trade'
    },
    defaultProposedExpirationDate: function () {
      let defaultDate = moment.tz(new Date(), moment.tz.guess()).add((this.currentDealer.prePurchaseInspectionExpiry || 0), 'day').format('YYYY-MM-DD 00:00:00')
      return defaultDate
    },
    ppaInfo: function () {
      return this.currentInventory && (this.currentInventory.ppaExaminedBy !== '' && this.currentInventory.ppaExaminedAt !== null) ? this.currentInventory.ppaExaminedBy + ' - ' + this.$options.filters.formatDateOnlyShort(this.currentInventory.ppaExaminedAt) : ''
    },
    isArchivePpaClosed: function () {
      return this.inventoryItem && this.inventoryItem.status === 'Archived' && this.inventoryItem.type === 'PpaClosed'
    },
    inventoryItemId: function () {
      return this.inventoryItem ? this.inventoryItem.id : null
    },
    modalTitle () {
      return 'View Pre-Purchase Appraisal Value'
    },
    stockNo () {
      return this.inventoryItem ? this.inventoryItem.stockNo : ''
    },
    inventoryDetails () {
      return this.inventoryItem && this.inventoryItem.vehicleInfo ? this.inventoryItem.vehicleInfo : this.inventoryItem.name
    },
    applicableIconTitle () {
      return 'Click to view approved PPA value'
    },
    formatIconByStatus () {
      var result = 'has-text-success'
      let classToAttach = {}
      classToAttach[result] = true
      return classToAttach
    },
    selectedInventoryStatusType: function () {
      return this.definedTypes.inventoryTypes.find((x) => (x.name === this.currentInventory.type || x.altName === this.currentInventory.type))
    },
    carFaxReportUrl: function () {
      let result = 'https://www.carfaxonline.com/cfm/Display_Dealer_Report.cfm?partner=VAU_0&UID=' + this.currentDealer.carFaxUserName + '&vin=' + this.currentInventory.vinNo
      return result
    },
    hasVautoAppraisal: function () {
      return this.currentInventory.vAutoAppId && this.currentInventory.vAutoAppId !== ''
    },
    mostRecentAppraisal: function () {
      if (this.currentInventory && this.currentInventory.appraisals && this.currentInventory.appraisals.length > 0) {
        return this.currentInventory.appraisals[0]
      }
      return null
    },
    inventoryAppraisalParams: function () {
      let trimAttribute = this.currentInventory.attributes.filter((x) => x.name === 'Trim')[0]
      let trim = trimAttribute ? trimAttribute.value : ''
      let condition = this.currentInventory.conditionType
      return {
        id: this.currentInventory.id,
        vinNo: this.currentInventory.vinNo,
        mileage: this.currentInventory.usage,
        trim: trim,
        condition: condition,
        msrp: this.currentInventory.msrp,
        purchaseCost: this.currentInventory.type === 'Consigned' ? this.currentInventory.consignmentMinimum : this.currentInventory.purchaseCostTotal,
        askingPrice: this.currentInventory.askingPrice
      }
    },
    proposedCostLabel: function () {
      return this.isTradePpaIntention ? 'ACV Value' : 'Proposed Purchase Price'
    },
    proposedCostExpirationLabel: function () {
      return this.isTradePpaIntention ? 'ACV Value Expiration Date' : 'Purchase Price Expiration Date'
    },
    ppaAgreementApprovals: function () {
      if (this.inventoryItem && this.inventoryItem.approvals) {
        let data = this.inventoryItem.approvals.filter((x) => x.approvalRatingType === 'PpaApproval')
        if (data.length > 0) {
          return data
        }
      }
      return []
    },
    hasAutoCheckRatingApproval: function () {
      if (this.ppaAgreementApprovals && this.ppaAgreementApprovals.length > 0) {
        let data = this.ppaAgreementApprovals.filter((x) => x.ratingType === 'AutoCheckRating')
        if (data.length > 0) {
          return true
        }
      }
      return false
    },
    hasCarFaxRatingApproval: function () {
      if (this.ppaAgreementApprovals && this.ppaAgreementApprovals.length > 0) {
        let data = this.ppaAgreementApprovals.filter((x) => x.ratingType === 'CarFaxRating')
        if (data.length > 0) {
          return true
        }
      }
      return false
    },
    hasAppraisalRatingApproval: function () {
      if (this.ppaAgreementApprovals && this.ppaAgreementApprovals.length > 0) {
        let data = this.ppaAgreementApprovals.filter((x) => x.ratingType === 'AppraisalRating')
        if (data.length > 0) {
          return true
        }
      }
      return false
    },
    autoCheckEnabled: function () {
      if (this.currentDealer) {
        return this.currentDealer.autoCheckEnabledStatus
      }
      return false
    },
    mostRecentBlackBookInformation: function () {
      if (this.blackBookInformation) {
        return this.blackBookInformation
      } else {
        if (this.currentInventory && this.currentInventory.blackBook) {
          return this.currentInventory.blackBook
        }
      }
      return null
    },
    blackBookEnabled: function () {
      if (this.currentDealer) {
        return this.currentDealer.blackBookEnabledStatus
      }
      return false
    },
    selectedDispositionDay: function () {
      if (this.currentInventory && this.currentInventory.dispositionValidDays) {
        return this.currentInventory.dispositionValidDays
      }
      return ''
    },
    ppaIntentionValue: function () {
      if (this.selectedPpaIntention && this.selectedPpaIntention.name) {
        return this.selectedPpaIntention.name
      }
      return ''
    },
    cpoStatusValue: function () {
      if (this.selectedCpoStatus && this.selectedCpoStatus.name) {
        return this.selectedCpoStatus.name
      }
      return ''
    },
    conditionTypeValue: function () {
      if (this.selectedConditionType && this.selectedConditionType.name) {
        return this.selectedConditionType.name
      }
      return ''
    },
    dispositionIntentionStatusValue: function () {
      if (this.selectedDispositionIntentionStatus && this.selectedDispositionIntentionStatus.name) {
        return this.selectedDispositionIntentionStatus.name
      }
      return ''
    }
  },
  methods: {
    onViewApprovedPpaValue: function () {
      this.serverErrorMessage = ''
      this.serverErrors = []
      if (this.inventoryItem && this.inventoryItem.id) {
        this.isApprovedPpaConfirmationActive = true
        this.loadInventory(this.inventoryItem.id)
      }
    },
    onCancel: function () {
      this.isApprovedPpaConfirmationActive = false
      this.reset()
    },
    reset: function () {
      this.serverErrors = []
      this.serverErrorMessage = []
      this.selectedWindowStickerStatus = null
      this.windowStickerFiles = []
      this.windowStickerPdfFiles = []
      this.blackBookCheckComplete = !this.blackBookEnabled
    },
    loadInventory (id) {
      this.isLoading = true
      inventoryService.getForPpaApproval(id).then(response => {
        this.currentInventory = response.inventory
        this.currentInventory.inspectionDependent = true
        this.selectedPpaIntention = this.definedTypes.ppaIntentionType.options.find(x => x.name === this.currentInventory.ppaIntention)
        this.selectedDispositionIntentionStatus = this.definedTypes.dispositionIntentionStatuses.find(x => x.altName === this.currentInventory.dispositionIntention)
        if (this.currentInventory.cpoStatus) {
          this.selectedCpoStatus = this.definedTypes.cpoStatusTypes.find(x => x.altName === this.currentInventory.cpoStatus)
        }
        if (this.currentInventory.conditionType) {
          this.selectedConditionType = this.definedTypes.inventoryConditionType.find(x => x.altName === this.currentInventory.conditionType)
        }
        if (!this.currentInventory.proposedCostExpirationDate) {
          this.currentInventory.proposedCostExpirationDate = this.defaultProposedExpirationDate
        }
        if (this.currentInventory.commitmentFromId > 0) {
          this.selectedCommitmentFrom = {
            id: this.currentInventory.commitmentFromId,
            name: this.currentInventory.commitmentFromName
          }
        }
        this.selectedWindowStickerStatus = this.definedTypes.windowStickerStatusOptions.find((x) => (x.name === this.currentInventory.windowStickerStatus || x.altName === this.currentInventory.windowStickerStatus))
        this.currentInventory.attachments.forEach((x) => {
          x.loaded = true
          x.imageData = x.fileLocation
          x.fileType = this.getFileType(x.fileLocation)

          if (x.type !== 'Pdf' && x.classType === 'WindowSticker' && x.status === 'Active') {
            this.windowStickerFiles.push(x)
          }
          if (x.type === 'Pdf') {
            if (x.classType === 'WindowSticker' && x.status === 'Active') {
              this.windowStickerPdfFiles.push(x)
            }
          }
        })
        this.isLoading = false
      }).catch((error) => {
        this.serverErrorMessage = error.message
      })
    },
    onAutoCheckForApprovePpa: function (autoCheckRating) {
    },
    onShowAutoCheckReport: function () {
      this.isApprovedPpaConfirmationActive = false
      this.showReport = true
    },
    onHideAutoCheckReport: function () {
      this.showReport = false
      this.isApprovedPpaConfirmationActive = true
    },
    onCarFaxForApprovePpa: function (carFaxRating) {
    },
    onShowCarFaxReport: function () {
      this.isApprovedPpaConfirmationActive = false
      this.showCarFaxReport = true
    },
    onHideCarFaxReport: function () {
      this.showCarFaxReport = false
      this.isApprovedPpaConfirmationActive = true
    },
    onAppraised: function (appraisal) {
    },
    onStockNoClick: function (inventoryItem) {
      let that = this

      if (inventoryItem && inventoryItem.stockNo !== '') {
        this.$copyText(inventoryItem.stockNo).then(
          function (e) {
            that.$buefy.toast.open({
              duration: 2500,
              message: 'Stock No. ' + inventoryItem.stockNo + ' copied to clipboard',
              position: 'is-top',
              type: 'is-info'
            })
          }, function (e) {
            that.$buefy.toast.open({
              duration: 2500,
              message: 'Could not copy stock no. to clipboard',
              position: 'is-top',
              type: 'is-warning'
            })
          }
        )
      }
    },
    uploadStarted: function () {
      this.fileUploadCount++
      this.isUploadingFile = true
    },
    uploadComplete: function () {
      this.fileUploadCount--
      if (this.fileUploadCount === 0) {
        this.isUploadingFile = false
      }
    },
    onAutoCheckDisabled: function () {
    },
    onBlackBookInformationRetrieved: function (blackBook) {
    },
    onBlackBookDisabled: function () {
      this.blackBookCheckComplete = true
      this.blackBookCheckIsGood = true
      this.blackBookCheckFailed = false
    }
  },
  watch: {
    inventoryItem: function (newValue, oldValue) {
      if (newValue) {
        this.selectedPpaIntention = this.definedTypes.ppaIntentionType.options.find(x => x.name === newValue.ppaIntention)
      } else {
        this.selectedPpaIntention = null
      }
    },
    inventoryItemId: function (newValue, oldValue) {
      if (oldValue && newValue) {
        this.reset()
      }
    },
    selectedDispositionIntentionStatus: function (newValue, oldValue) {
      if (this.currentInventory) {
        let originalDispositionIntention = this.currentInventory.dispositionIntention
        if (originalDispositionIntention === newValue) {
          if (newValue && (newValue.id === 2 || newValue.id === 3)) {
            if (this.currentInventory.commitmentFromId !== null && this.currentInventory.commitmentFromId > 0) {
              this.hasCommitment = true
              this.selectedCommitmentFrom = {
                id: this.currentInventory.commitmentFromId,
                name: this.currentInventory.commitmentFromName
              }
            } else {
              this.hasCommitment = false
            }
          }
        } else {
          this.hasCommitment = false
          this.currentInventory.firmCommitment = null
          this.selectedCommitmentFrom = null
          this.currentInventory.dispositionValidDays = null
        }
      }
    }
  },
  mounted () {
    this.selectedPpaIntention = this.definedTypes.ppaIntentionType.options.find(x => x.name === this.inventoryItem.ppaIntention)
    if (!this.currentDealer || !this.currentDealer.blackBookEnabled) {
      this.blackBookCheckComplete = true
    }
  }
}

</script>

<style scoped>
  .content ul{
    list-style-type: none;
    margin-top: 0
  }

  .modal-card-head, .modal-card-foot{
    padding: 20px !important
  }

  .vauto-container {
    margin-top: 20px;
    padding: 0;
    margin-left: 0;
    margin-right: 0;
  }

  .vauto-container-display-only {
    display: inline-flex;
    flex-flow: row;
    align-items: center;
    margin-top:10px;
  }

  .modal-fullscreen .modal-card {
    max-width: 100%;
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    position: fixed;
    z-index: 100000;
    max-height: 100% !important;
  }

  .modal-card-body {
    overflow:auto;
    height: calc(110vh - 350px);
  }

</style>
